(function (angular) {
    'use strict';
    var app = angular.module('enervee');

    /*
     This directive scrolls user to a specific section in the page identified by its id

     Usage example:
     <a
        data-go-to-section="section-id">
     </a>

     */
    app.directive('goToSection', [
        'UtilService',
        function (
            UtilService
        ) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {

                    element.bind('click', function() {
                        UtilService.goToSection(attrs.goToSection);
                    });

                }
            };
        }
    ]);
})(angular);